import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography, Link } from "@material-ui/core";
import ScrollAnimation from "react-animate-on-scroll";
import "animate.css/animate.min.css";
import {
  COLOR_FONT,
  COLOR_HIGH,
  COLOR_MID,
  SPACING_MED,
  SPACING_XBIG,
  SPACING_XSMALL,
} from "../constants";

const useStyles = makeStyles((theme) => ({
  root: {
    marginLeft: SPACING_MED,
    marginRight: SPACING_MED,
    marginBottom: SPACING_XBIG,
    color: COLOR_FONT,
    [theme.breakpoints.up("md")]: {
      marginLeft: "15%",
      marginRight: "15%",
    },
  },
  title: {
    color: COLOR_HIGH,
    marginTop: SPACING_XBIG,
    marginBottom: SPACING_MED,
    paddingTop: SPACING_MED,
  },
  subtitle: {
    color: COLOR_MID,
    marginTop: SPACING_MED,
    marginBottom: SPACING_XSMALL,
  },
  desc: { marginBottom: SPACING_XSMALL },
  link: { color: COLOR_HIGH },
}));

function Contact() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <ScrollAnimation animateIn="fadeIn" offset={50}>
        <Typography
          variant="h3"
          component="h3"
          className={classes.title}
          id={"contact"}
        >
          CONTACT
        </Typography>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.desc}
        >
          Am I the perfect fit for your company or project?
        </Typography>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.desc}
        >
          Would you like to talk about my experience and projects more?
        </Typography>
        <Typography variant="h4" component="h4" className={classes.subtitle}>
          CONTACT ME RIGHT AWAY!
        </Typography>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.desc}
        >
          <Link href="mailto:ryanwoolee@gmail.com" className={classes.link}>
            ryanwoolee@gmail.com
          </Link>
        </Typography>
      </ScrollAnimation>
    </div>
  );
}

export default Contact;
